import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { LocalStorageKeys, localStorageHelper } from '../helpers/localStorage.helper';

export interface Home {
  isLoading: boolean;
  menuIsOpened: boolean;
  currentWidth: number;
}

// Отримати початковий стан меню з localStorage
const getInitialMenuState = (): boolean => {
  const savedState = localStorageHelper.get(LocalStorageKeys.MENU_IS_OPENED);
  if (savedState !== null) {
    return savedState === 'true';
  }
  return true; // За замовчуванням меню відкрите
};

const initialState: Home = {
  isLoading: false,
  menuIsOpened: getInitialMenuState(),
  currentWidth: 0,
};

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsOpenMenu: (state, action: PayloadAction<boolean>) => {
      state.menuIsOpened = action.payload;
    },
    setCurrentWidth: (state, action: PayloadAction<number>) => {
      state.currentWidth = action.payload;
    },
  },
});

export const { setCurrentWidth } = homeSlice.actions;

export const selectCurrentWidth = (state: RootState) => state.home.currentWidth;
export const { setIsLoading, setIsOpenMenu } = homeSlice.actions;

export default homeSlice.reducer;
